import { useEffect, useRef } from 'react';
import { useActionLogSender } from '@framework/action-log';

/**
 * 以下の2つの場面で再読み込みを行う。
 *  - ブラウザのタブがスリープから復帰したとき(resumeしたとき)
 *  - Balusをロードしてから12時間経過した後に、タブがアクティブになった時
 */
export const ReloadOnResume: React.FC = () => {
  const logSender = useActionLogSender();
  const loadedAtRef = useRef<number>(Date.now());

  useEffect(() => {
    // ブラウザの visibility が変化した時、Resumeした時、フォーカスが当たった時、ページ表示された時、
    // 初回ロードから12時間経過している場合には、強制的に再読み込みを行う。
    // (古いバージョンのコードのまま動き続けることを抑制するため)
    const handleChangeVisibility = async () => {
      if (document.visibilityState !== 'visible') {
        return;
      }

      const now = Date.now();
      const elapsed = now - loadedAtRef.current;
      if (elapsed < 12 * 60 * 60 * 1000) {
        return;
      }

      await logSender('global:reload', {
        cause: '12 hours elapsed',
      });
      window.location.reload();
    };

    const events = ['visibilitychange', 'resume', 'focus', 'pageshow'];
    for (const event of events) {
      document.addEventListener(event, handleChangeVisibility);
    }

    return () => {
      for (const event of events) {
        document.removeEventListener(event, handleChangeVisibility);
      }
    };
  }, [logSender]);

  return <></>;
};
